import { constants } from '../../shared/constants/constants';

export const temporary = {
  overridesOfRecommendationProfileSelection: [
    {
      productId: constants.productNames.cems.id,
      matchProfileType: constants.equilibré.name,
      replaceToTabName: constants.recommendationTabs.gestionSousMandat.name,
      replaceToProfileName: constants.modere.name
    },
    {
      productId: constants.productNames.cims.id,
      matchProfileType: constants.equilibré.name,
      replaceToTabName: constants.recommendationTabs.gestionSousMandat.name,
      replaceToProfileName: constants.modere.name
    }
  ]
};

export interface OverridesOfRecommendationProfileSelection {
  productId: number;
  matchProfileType: string;
  replaceToTabName: string;
  replaceToProfileName: string;
}
